
skrilla.controller('franchiseDetailsCtrl', function ($scope, searchService, $stateParams, modalService, cacheService, dataService, queryService, envService, countryService) {
    $scope.sport = $stateParams.sport;
    cacheService.registerObject("contestSport", $scope.sport);
    $scope.validate = {}

    $scope.countries = countryService.getAllCountries()


    $scope.sports = [
        "CSGO",
        "LOL",
        "STARCRAFT",
        "DOTA2",
        "ROCKET_LEAGUE",
        "OVERWATCH",
        "PUBG"
    ];

    searchService.get("franchises/" + $scope.sport + "/" + $stateParams.id).then(function(response){
        $scope.franchise = response.data;
    })

    $scope.reset = function(){
        $scope.query = {};
    }
    $scope.reset();

    $scope.search = function(){
        searchService.get("franchises/" + $scope.sport + "/" + $stateParams.id + "/players" + queryService.getQueryString($scope.query)).then(function(response1){
            $scope.players = response1.data;
        });
    }

    $scope.mergeTournament = function(){
        cacheService.registerObject("franchise", $scope.franchise);
        modalService.openModal("views/mergeTournamentModal/mergeTournamentModal.html", true, 'lg', true, true);
    }

    $scope.addPlayer = function(){
        cacheService.registerObject("franchise", $scope.franchise);
        modalService.openModal("views/addPlayerToFranchiseModal/addPlayerToFranchiseModal.html", true, 'lg', true, true);
    }

    $scope.save = function(){
        if(dataService.validateFranchise($scope.franchise, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to update this franchise?", function () {
                searchService.put("franchises/" + $scope.sport + "/" + $scope.franchise.id, $scope.franchise, "Successfully updated").then(function (response) {
                    $scope.sport = $scope.franchise.sport;
                    cacheService.registerObject("contestSport", $scope.sport);
                });
            });
        }
    }

    //Pre load the widget so user doesn't have to wait
    const createMediaLibrary = function (envService, $scope) {
        if ($scope.mediaLibraryWidget) {
            return $scope.mediaLibraryWidget;
        }
        if (typeof cloudinary === 'undefined') {
            console.log("Cloudinary not available")
            return
        }

        $scope.mediaLibraryWidget = cloudinary.createMediaLibrary({
              ...envService.read('cloudinary'),
              multiple: false,
              max_files: 1
          }, {
              insertHandler: function (data) {
                  data.assets.forEach(asset => {
                      $scope.$apply(() => {
                          if (asset.derived && asset.derived.length > 0) {
                              $scope.franchise.iconUri = asset.derived[0].secure_url;
                          } else {
                              $scope.franchise.iconUri = asset.secure_url;
                          }
                      })
                  })
              }
          }
        );
        return $scope.mediaLibraryWidget;
    };

    createMediaLibrary(envService, $scope);

    $scope.openLibraryWidget = function() {
        createMediaLibrary(envService, $scope).show({
            folder: {resource_type: "image"},
        });
    }
});
